import { IAccountDto } from "../DTOs/IAccountDto";
import { IJsonWebToken } from "../DTOs/IJsonWebToken";
import { authService } from "./authService";

export default class ApiRoutingService {

    static readonly apiUrl: string = "https://testapi.mediti.pl";
    static readonly apiToken: string = "90edcd2d9d84cbbe74556ebc5726e84f1e459b5deadcbd79472808adbd43290b";

    public static getMeditationsFetchUrl(): string {
        return `${this.apiUrl}/meditations-module/Meditations/`;
    }

    public static async changePassword(token: string, password: string): Promise<boolean> {
        let url = `${this.apiUrl}/users-module/Account/password-change/`;

        const data = {
            token: token,
            password: password
        };

        let response = await fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'XApiKey': `${this.apiToken}`,
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            return true;
        } else {
            const error = new Error("ERROR");
            return Promise.reject(error);
        }
    }

    public static async logIn(email: string, password: string): Promise<boolean> {
        let url = `${this.apiUrl}/users-module/Account/sign-in/`;

        const data = {
            email: email,
            password: password
        };

        let response = await fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'XApiKey': `${this.apiToken}`,
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            const jwt: IJsonWebToken = await response.json();
            authService.setToken(jwt.accessToken);
            authService.setUserData(jwt.name, jwt.id);
            return true;
        } else {
            const error = new Error("ERROR");
            return Promise.reject(error);
        }
    }

    public static async signUp(email: string, password: string, name: string, termsConsent: boolean, newsletterConsent: boolean): Promise<boolean> {
        let url = `${this.apiUrl}/users-module/Account/sign-up/`;

        const data = {
            email: email,
            password: password,
            name: name,
            termsConsent: termsConsent,
            newsletterConsent: newsletterConsent
        };

        let response = await fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'XApiKey': `${this.apiToken}`,
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            return true;
        } else {
            const error = new Error("ERROR");
            return Promise.reject(error);
        }
    }

    public static logOut() {
        authService.removeCookies();
    }

    public static async getUserData(): Promise<IAccountDto> {
        let url = `${this.apiUrl}/users-module/Account`;
        let token = authService.getToken();

        if (token == null || token == undefined) {
            return Promise.reject(new Error("NO TOKEN"));
        }

        let response = await fetch(url, {
            method: "GET",
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'XApiKey': `${this.apiToken}`,
                'Authorization': `Bearer ${token}`
            },
        });

        if (response.ok) {
            const acc: IAccountDto = await response.json();
            return acc;
        } else {
            const error = new Error("ERROR");
            return Promise.reject(error);
        }
    }

    public static async updateNewsletterConsent(newsletterConsent: boolean): Promise<boolean> {
        let url = `${this.apiUrl}/users-module/account/newsletter-consent`;
        let token = authService.getToken();

        if (token == null || token == undefined) {
            return Promise.reject(new Error("NO TOKEN"));
        }

        const data = {
            NewsletterConsent: newsletterConsent
        };

        let response = await fetch(url, {
            method: "PATCH",
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'XApiKey': `${this.apiToken}`,
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            return true;
        } else {
            const error = new Error("ERROR");
            return Promise.reject(error);
        }
    }

    public static async signUpForNewsletter(email: string, name: string): Promise<boolean> {
        let url = `${this.apiUrl}/notifications-module/Newsletter`;

        const data = {
            email: email,
            name: name
        };

        let response = await fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'XApiKey': `${this.apiToken}`,
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            return true;
        } else {
            const error = new Error("ERROR");
            return Promise.reject(error);
        }
    }
}